import * as XLSX from 'xlsx';

// Multi-tab Excel sheet picker. Ported from CPAiSuite Universal (spec §4.1).

const NAME_KEYWORDS = ['name', 'employee', 'emp'];
const AMOUNT_KEYWORDS = [
	'gross',
	'net',
	'salary',
	'pay',
	'wage',
	'earnings',
	'amount',
	'total',
];

function sheetToRows(ws: XLSX.WorkSheet): string[][] {
	const raw = XLSX.utils.sheet_to_json<unknown[]>(ws, {
		header: 1,
		raw: true,
		defval: '',
		blankrows: false,
	});
	return raw.map((r) => (r as unknown[]).map((c) => (c == null ? '' : String(c))));
}

function countNumericCells(row: string[]): number {
	return row.filter((c) => {
		const v = String(c).trim();
		return v !== '' && Number.isFinite(Number(v));
	}).length;
}

/** Score every sheet. Exposed so the wizard can show scores / a switcher. */
export function scoreSheets(
	workbook: XLSX.WorkBook
): Array<{ name: string; score: number }> {
	return workbook.SheetNames.map((name) => {
		const rows = sheetToRows(workbook.Sheets[name]);
		const headerCandidates = rows.slice(0, 10);
		const candidateText = headerCandidates.map((r) =>
			r.join(' ').toLowerCase()
		);

		let score = 0;
		if (candidateText.some((line) => NAME_KEYWORDS.some((k) => line.includes(k)))) {
			score += 10;
		}
		if (
			candidateText.some((line) => AMOUNT_KEYWORDS.some((k) => line.includes(k)))
		) {
			score += 10;
		}
		for (const row of headerCandidates) {
			if (countNumericCells(row) >= 2) score += 1;
		}
		score += rows.length; // prefer larger sheets

		return { name, score };
	});
}

/** Returns the name of the highest-scoring sheet. */
export function findBestSheet(workbook: XLSX.WorkBook): string {
	if (workbook.SheetNames.length <= 1) {
		return workbook.SheetNames[0];
	}
	const scored = scoreSheets(workbook);
	let best = scored[0];
	for (const s of scored) {
		if (s.score > best.score) best = s;
	}
	// All sheets scored 0 -> fall back to the first sheet.
	if (best.score === 0) return workbook.SheetNames[0];
	return best.name;
}
